<template>
    <form 
        @submit.prevent="submit" 
        class="form" 
        :class="{'form--loading': loading}">
        <div class="grid-x grid-padding-x grid-padding-y">
            <div class="cell">
                <input-field 
                    v-model="datamodel.email"
                    name="email"
                    v-validate="'required|email'"
                    label="E-mailadres"
                    :errors="errors"
                    placeholder="E-mailadres" />
            </div>
            <div class="cell">
                <password-field 
                    v-model="datamodel.password"
                    name="password"
                    v-validate="'required|min:6'"
                    label="Wachtwoord"
                    :errors="errors"
                    placeholder="Je wachtwoord" />
            </div>
            <div class="cell">
                <div class="btn-holder btn-holder--center">
                    <submit-field>
                        Inloggen
                    </submit-field>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { mapActions } from 'vuex';
import { ScrollToError } from '@/helpers';

export default {
    inject: ['$validator'],
    data() {
        return {
            loading: false,
            datamodel: {
                email: '',
                password: '',
            },
        };
    },
    methods: {
        ...mapActions({
            'login': 'sportid/login'
        }),
        submit() {
            this.$validator.validateAll().then((success) => {
                if(success) {
                    this.loading = true;

                    this.login(this.datamodel).then(() => {
                        this.$router.push({
                            name: 'redeem_voucher',
                            params: this.$route.params,
                            query: this.$route.query,
                        });
                    }, ({data}) => {
                        if(data.status === 422) {
                            Object.entries(data.errors).forEach((item) => {
                                this.errors.add({
                                    field: item[0],
                                    msg: item[1][0],
                                });
                            });

                            ScrollToError(this.$el);
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
                } else {
                    ScrollToError(this.$el);
                }                
            });
        },
    },
};
</script>
